export type DataTableColumnWidthMap = Record<string, number>;

const MIN_COLUMN_WIDTH_PX = 56;
const DEFAULT_COLUMN_WIDTH_PX = 120;

export function parseDataTableColumnWidth(
  width: string | undefined,
  tableWidthPx: number,
  fallbackPx = DEFAULT_COLUMN_WIDTH_PX,
): number {
  if (!width?.trim()) return Math.max(MIN_COLUMN_WIDTH_PX, fallbackPx);
  const raw = width.trim();
  if (raw.endsWith('%')) {
    const pct = parseFloat(raw);
    if (Number.isFinite(pct)) {
      return Math.max(MIN_COLUMN_WIDTH_PX, Math.round((tableWidthPx * pct) / 100));
    }
  }
  if (raw.endsWith('px')) {
    const px = parseFloat(raw);
    if (Number.isFinite(px)) return Math.max(MIN_COLUMN_WIDTH_PX, Math.round(px));
  }
  if (raw.endsWith('rem')) {
    const rem = parseFloat(raw);
    if (Number.isFinite(rem)) return Math.max(MIN_COLUMN_WIDTH_PX, Math.round(rem * 16));
  }
  return Math.max(MIN_COLUMN_WIDTH_PX, fallbackPx);
}

export const DATA_TABLE_MIN_COLUMN_WIDTH_PX = MIN_COLUMN_WIDTH_PX;
export const DATA_TABLE_DEFAULT_COLUMN_WIDTH_PX = DEFAULT_COLUMN_WIDTH_PX;

/** Layout reference for narrow horizontal-scroll column sizing (% → px). */
export const DATA_TABLE_HORIZONTAL_SCROLL_REF_PX = 1280;

/** Pin-start column max on narrow — keeps next columns peeking for scroll affordance. */
export const DATA_TABLE_PIN_START_NARROW_MAX_PX = 176;
